import script from "./CookieInfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CookieInfoModal.vue?vue&type=script&setup=true&lang=ts"

import "./CookieInfoModal.vue?vue&type=style&index=0&id=b9673eea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9673eea"]])

export default __exports__